<template>
    <section class="container-fluid header-pc d-none d-md-block" :class="isFixed?'fixed':''">
        <div class="container">
            <div class="center">
                <router-link class="item" to="/square">模型广场</router-link>
                <i class="line"></i>
                <router-link class="item" to="/dataSet">数据集</router-link>
                <i class="line"></i>
                <router-link class="item" to="/service">软件与服务</router-link>
                <i class="line"></i>
                <router-link class="item" to="/">科学地平线</router-link>
            </div>
            <div class="right">
                <div class="search-box style-white">
                    <input type="text" class="uc-input" placeholder="模型、数据集、应用软件" value="" placeholder-class="uc-phColor" />
                    <div class="btn"><img src="@/assets/images/icon-search.png" alt=""></div>
                </div>
                <router-link class="uc-btn blue" to="">登录</router-link>
            </div>
        </div>
    </section>
    <!-- 手机版 -->
    <section class="header-phone d-md-none">
        <router-link class="logo" to="/">
            <img src="@/assets/images/logo.png" alt="">
        </router-link>
        <div class="btn-menu" :class="showMenu?'on':''" @click="showMenu = !showMenu"></div>
    </section>
    <div class="alert-menu" v-if="showMenu">
        <div class="over-close" @click="showMenu = false"></div>
        <div class="box">
            <ul class="list">
                <li>
                    <router-link class="" to="/square">模型广场</router-link>
                </li>
                <li>
                    <router-link class="" to="/dataSet">数据集</router-link>
                </li>
                <li>
                    <router-link class="" to="/service">软件与服务</router-link>
                </li>
                <li>
                    <router-link class="" to="/">科学地平线</router-link>
                </li>
            </ul>
            <div class="search-box">
                <input type="text" class="uc-input" placeholder="模型、数据集、应用软件" value="" placeholder-class="uc-phColor" />
                <div class="btn"><img src="@/assets/images/icon-search.png" alt=""></div>
            </div>
        </div>
    </div>
</template>
<script setup>
    import { ref, onMounted, onUnmounted } from 'vue'
    const showMenu = ref(false)
    const name = ref('小')
    const isFixed = ref(false)
    const handleScroll = () => {
        isFixed.value = window.pageYOffset > 300
    }
    let timer = null
    const throttledScroll = () => {
        if (!timer) {
            timer = setTimeout(() => {
                handleScroll()
                timer = null
            }, 50)
        }
    }
    onMounted(() => {
        window.addEventListener('scroll', throttledScroll)
    })
    onUnmounted(() => {
        window.removeEventListener('scroll', throttledScroll)
        clearTimeout(timer)
    })
</script>